import {useFormContext} from 'react-hook-form'

export function useRouteOptimizationButton() {
  const {watch, setValue} = useFormContext()

  function setRouteUnoptimized(): void {
    if (watch().hasOwnProperty('is_route_optimized')) {
      setValue('is_route_optimized', false)
    }
  }

  return {
    setRouteUnoptimized,
  }
}
